import React from "react";
import { cn } from "../../styles";

export interface DividerProps {
  className?: string;
  vertical?: boolean;
}

export function Divider({ className, vertical = false }: DividerProps) {
  return (
    <hr
      className={cn(
        "border-back-200 dark:border-back-700 m-0",
        vertical ? "border-l border-t-0 h-full self-stretch" : "border-t w-full",
        className,
      )}
    />
  );
}
